import { NgModule } from '@angular/core';
import { ArticleDataAccessModule } from '@article/data-access';
import { ArticleFeatureLazyModule } from '@article/feature';
import { CustomProductCmsComponents } from '@core/const';
import { productI18nConfig } from '@product/const';
import { ProductDataAccessModule } from '@product/data-access';
import { ProductDataAccessModule as ProductDataAccessModuleV2 } from '@product/data-access/v2';
import { InterceptorsModule } from '@product/feature';
import { ProductFeatureModule as ProductFeatureModuleV2 } from '@product/feature/v2';
import { ConfigModule, provideConfig } from '@spartacus/core';

@NgModule({
  imports: [
    ArticleDataAccessModule,
    ArticleFeatureLazyModule,
    ProductDataAccessModule,
    ProductDataAccessModuleV2,
    ProductFeatureModuleV2,
    InterceptorsModule,
    ConfigModule.withConfig({
      featureModules: {
        ProductIntroComponent: {
          module: () => import('./lazy/custom-product-intro.module').then((m) => m.SdCustomProductIntroModule),
          cmsComponents: [CustomProductCmsComponents.ProductIntroComponent],
        },

        CustomProductDetails: {
          module: () => import('./lazy/custom-product-details-tab.module').then((m) => m.CustomProductDetailsTabModule),
          cmsComponents: [CustomProductCmsComponents.ProductDetailsTabComponent],
        },

        ProductReferences: {
          module: () =>
            import('./lazy/custom-product-references.module').then((m) => m.SdCustomProductReferencesModule),
          cmsComponents: [CustomProductCmsComponents.ProductReferencesComponent],
        },

        ProductCarousel: {
          module: () => import('./lazy/product-carousel.module').then((m) => m.SdvorCustomProductCarouselModule),
          cmsComponents: [CustomProductCmsComponents.ProductCarouselComponent],
        },

        ProductGroupReferences: {
          module: () =>
            import('./lazy/product-group-references.module').then((m) => m.SdvorProductGroupReferencesModule),
          cmsComponents: [CustomProductCmsComponents.ProductGroupReferencesComponent],
        },

        ProductSpecsTab: {
          module: () => import('./lazy/product-attributes.module').then((m) => m.SdProductAttributesModule),
          cmsComponents: [
            CustomProductCmsComponents.ProductSpecsTabComponent,
            CustomProductCmsComponents.ProductMainSpecsComponent,
          ],
        },

        ProductAddToCart: {
          module: () => import('./lazy/custom-add-to-cart.module').then((m) => m.SdProductAddToCartModule),
          cmsComponents: [CustomProductCmsComponents.ProductAddToCartComponent],
        },

        ProductScrollToCalculator: {
          module: () =>
            import('./lazy/product-scroll-to-calculator.module').then((m) => m.ProductScrollToCalculatorModule),
          cmsComponents: [CustomProductCmsComponents.RosaCMSProductScrollToCalculatorComponent],
        },

        ProductPrice: {
          module: () => import('./lazy/product-price.module').then((m) => m.SdvorProductPriceModule),
          cmsComponents: [CustomProductCmsComponents.SdCMSProductPriceComponent],
        },

        ProductManualPrice: {
          module: () => import('./lazy/product-manual-price.module').then((m) => m.SdvorProductManualPriceModule),
          cmsComponents: [CustomProductCmsComponents.RosaCMSManualPriceComponent],
        },

        ProductDataSheetTab: {
          module: () => import('./lazy/product-documents.module').then((m) => m.SdProductDocumentsModule),
          cmsComponents: [CustomProductCmsComponents.SdCMSProductDataSheetTabComponent],
        },

        ProductMarketingAttributes: {
          module: () =>
            import('./lazy/product-marketing-attributes.module').then((m) => m.SdvorProductMarketingAttributesModule),
          cmsComponents: [CustomProductCmsComponents.SdCMSProductMarketingAttributesComponent],
        },

        ProductImages: {
          module: () => import('./lazy/custom-product-images.module').then((m) => m.SdCustomProductImagesModule),
          cmsComponents: [CustomProductCmsComponents.ProductImagesComponent],
        },

        TabParagraphContainer: {
          module: () =>
            import('./lazy/custom-tab-paragraph-container.module').then((m) => m.SdCustomTabParagraphContainerModule),
          cmsComponents: [CustomProductCmsComponents.CMSTabParagraphContainer],
        },

        ProductArticlesTab: {
          module: () => import('./lazy/product-articles.module').then((m) => m.SdvorProductArticlesModule),
          cmsComponents: [CustomProductCmsComponents.SdCMSProductArticlesTabComponent],
        },

        ProductCalculator: {
          module: () => import('./lazy/product-calculator.module').then((m) => m.ProductCalculatorModule),
          cmsComponents: [CustomProductCmsComponents.SdCMSCalculatorComponent],
        },

        ProductCard: {
          module: () => import('./lazy/product-card.module').then((m) => m.CmsProductCardModule),
          cmsComponents: [CustomProductCmsComponents.RosaCMSProductCardComponent],
        },
      },
    }),
  ],
  providers: [provideConfig(productI18nConfig)],
})
export class SdvorProductShellModule {}
